<template>
    <section class="activate-beacon-view">
        <div class="modal-header">
            <h3>Activate Beacon</h3>
        </div>
        <app-form ref="beaconsForm" @submit.native.prevent="submit">
            <app-alert v-if="error" type="error">{{ error.message }}</app-alert>
            <app-form-item label="Beacon Factory ID" prop="factory_id" class="beacon-input">
                <app-input
                    id="factory_id"
                    v-model="beacon.factory_id"
                    :maxlength="10"
                    placeholder="XXXX-YYYYY"
                    @keyup.native="setLastKey"
                    @input="formatInput"/>
            </app-form-item>

            <div class="modal-footer">
                <app-button :loading="isSaving" type="primary" native-type="submit">Activate</app-button>
            </div>
        </app-form>
    </section>
</template>
<script>
import { first } from '@/utilities'
import Beacon from '@/store/models/Beacon'

export default {
    name: 'activate-beacon-view',
    inject: ['modalOptions'],
    props: ['noLocation'],
    data() {
        return {
            beacon: new Beacon,
            isSaving: false,
            error: null,
            lastKey: 0
        }
    },
    methods: {
        submit() {
            this.isSaving = true
            if (!this.beacon.factory_id) {
                return
            }
            this.beacon.immediately = true
            this.beacon.$create()
                .then(() => {
                    this.$notify({
                        title: 'Success',
                        message: 'The beacon has been activated successfully.',
                        type: 'success',
                        offset: 75,
                        duration: 10000
                    })

                    this.isSaving = false
                    this.modalOptions.modalOpen = false
                    this.$emit('activated', this.beacon)
                })
                .catch(errors => {
                    this.error = first(errors)
                    this.isSaving = false
                })
            return false
        },
        formatInput() {
            if (this.beacon.factory_id.length == 4 && this.lastKey != 8) {
                this.beacon.factory_id = this.beacon.factory_id + '-'
            }
            if (
                this.beacon.factory_id.length > 4 &&
                this.beacon.factory_id.indexOf('-') < 0
            ) {
                var context = this
                this.$nextTick(() => {
                    var str = context.beacon.factory_id
                    if (str.indexOf('-') < 0) {
                        context.beacon.factory_id = context.spliceDash(str)
                    }
                })
            }
        },
        setLastKey(event) {
            this.lastKey = event.keyCode
        },
        spliceDash(str) {
            return str.substring(0, 4) + '-' + str.substring(4, str.length)
        }
    }
}
</script>

<style lang="stylus">
#factory_id
    text-transform: uppercase
</style>
